import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"
import { mergeClasses as cn } from "../../helpers/styling"
import { TooltipPortalProps } from "@radix-ui/react-tooltip"

function TooltipProvider({
                           delayDuration = 0,
                           ...props
                         }: React.ComponentProps<typeof TooltipPrimitive.Provider>) {
  return (
    <TooltipPrimitive.Provider
      data-slot="tooltip-provider"
      delayDuration={delayDuration}
      {...props}
    />
  )
}

function Tooltip(props: React.ComponentProps<typeof TooltipPrimitive.Root> & {
  withProvider?: boolean
  providerProps?: Omit<React.ComponentProps<typeof TooltipPrimitive.Provider>, "children">
}) {
  if (props.withProvider === false) {
    return <TooltipPrimitive.Root data-slot="tooltip" {...props} />
  } else return (
    <TooltipProvider {...props.providerProps}>
      <TooltipPrimitive.Root data-slot="tooltip" {...props} />
    </TooltipProvider>
  )
}

function TooltipTrigger({
                          ...props
                        }: React.ComponentProps<typeof TooltipPrimitive.Trigger>) {
  return <TooltipPrimitive.Trigger data-slot="tooltip-trigger" {...props} />
}

/**
 * Customized for: outline, shadow, snappier animations, wistor colors, no pointer events, and other mini-tweaks
 */
function TooltipContent({
                          className,
                          labelClassNames,
                          arrowClassNames,
                          portalProps,
                          sideOffset = 0,
                          children,
                          ...props
                        }: React.ComponentProps<typeof TooltipPrimitive.Content> & {
  labelClassNames?: string
  arrowClassNames?: string
  portalProps?: TooltipPortalProps
}) {
  return (
    <TooltipPrimitive.Portal {...portalProps}>
      <TooltipPrimitive.Content
        data-slot="tooltip-content"
        sideOffset={sideOffset}
        className={cn(
          `position-relative inline-flex justify-center items-center
          animate-in fade-in-0 zoom-in-95
          duration-50 ease-linear zoom-in-[0.98]

          z-[2100] w-fit
          drop-shadow-[0_1px_2px_rgba(0,0,0,0.3)]
          pointer-events-none
          data-[state=closed]:animate-out
          data-[state=closed]:fade-out-0
          data-[state=closed]:zoom-out-95
          data-[side=bottom]:slide-in-from-top-2
          data-[side=left]:slide-in-from-right-2
          data-[side=right]:slide-in-from-left-2
          data-[side=top]:slide-in-from-bottom-2
          origin-(--radix-tooltip-content-transform-origin)`,
          className
        )}
        {...props}
      >
        <label className={cn(`
          position-relative z-10 m-0
          bg-wistor text-white
          outline outline-1 outline-black
          font-exo rounded-md px-2 py-1 text-xs text-balance`, labelClassNames)}>
          {children}
        </label>
        <TooltipPrimitive.Arrow className={cn(`
          position-relative size-2 z-0
          bg-black fill-black
          translate-y-[calc(-50%_-_1px)] rotate-45`, arrowClassNames)} />
      </TooltipPrimitive.Content>
    </TooltipPrimitive.Portal>
  )
}

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider }
